import TaxiCorporationAddParams from "../../../../../common/services/taxi-corporation/add/taxi-corporation-add-params";
import ContractMaintenancePolicy from "../../../../../common/types/contract-maintenance-policy";
import TaxiAddFormData from "../../../common/types/taxi-add-form-data";
import TaxiContractMaintenancePolicy from "../../../common/types/taxi-contract-maintenance-policy";

const createContractMaintenancePolicy = (
  contractMaintenancePolicy: TaxiContractMaintenancePolicy,
): ContractMaintenancePolicy => {
  switch (contractMaintenancePolicy) {
    case TaxiContractMaintenancePolicy.BASIC:
      return ContractMaintenancePolicy.BASIC;
    case TaxiContractMaintenancePolicy.AUCTION:
      return ContractMaintenancePolicy.BASIC;
  }
};

const create = (data: TaxiAddFormData) => {
  const params: TaxiCorporationAddParams = {
    companyName: data.companyName,
    krsNo: data.nationalCourtRegister || null,
    contractMaintenancePolicy: createContractMaintenancePolicy(
      data.contractMaintenancePolicy!,
    ),
    displayName: data.displayName,
    headquartersAddressString: data.address,
    notes: data.notes,
    regon: data.companyId || null,
    taxId: data.taxId,
  };

  return params;
};

const taxiAddFactory = {
  create,
};

export default taxiAddFactory;
